import { useQuery } from '@tanstack/react-query';

import { ApiClient } from '../api/apiClient';
import { Lookup } from '../models/api/Lookup';

export function useGetLookups(lookupName: string, enabled = true) {
  return useQuery<Lookup[]>({
    queryKey: ['lookups', lookupName],
    enabled: Boolean(lookupName) && enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const response = await ApiClient.get(
        `Lookup?lookupName=${encodeURIComponent(lookupName)}`
      );

      return response.data;
    },
  });
}
